// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1ZI1y","tab":"Tabs_tab__2-5tG","tabActive":"Tabs_tabActive__2bh6N"};